<h2 mat-dialog-title class="mb-3 dialog-title">Create Variation</h2>
<div class="dialog-header-fixed">
    <div class="input-row" [formGroup]="templateForm">
        <!--        <mat-form-field appearance="outline" class="me-3">-->
        <!--            <mat-label>Effective Date</mat-label>-->
        <!--            <input matInput [matDatepicker]="picker" [value]="effectiveDate" (dateChange)="onDateChange($event)">-->
        <!--            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>-->
        <!--            <mat-datepicker #picker></mat-datepicker>-->
        <!--        </mat-form-field>-->
        <mat-form-field appearance="outline" floatLabel="always" class="header-select me-3"
                        *ngIf="variationTemplates.length > 0">
            <mat-label>Variation Template</mat-label>
            <mat-select formControlName="template" (selectionChange)="onTemplateChange()">
                <mat-optgroup *ngFor="let group of groupedTemplates" [label]="group.scope">
                    <mat-option *ngFor="let template of group.templates"
                                [value]="template.id"
                                matTooltip="{{template.description}}">
                        {{ template.name }}
                    </mat-option>
                </mat-optgroup>
            </mat-select>
        </mat-form-field>
        <mat-form-field appearance="outline" class="me-3">
            <mat-label>Location Set</mat-label>
            <input matInput
                   formControlName="location"
                   [matAutocomplete]="auto"
                   placeholder="Search location sets...">
            <mat-autocomplete #auto="matAutocomplete"
                              [displayWith]="displayLocationSet.bind(this)"
                              (optionSelected)="onLocationSelected($event)">
                <mat-option *ngFor="let locationSet of filteredLocationSets | async" [value]="locationSet">
                    {{ locationSet.name }} ({{ locationSet.tag }})
                </mat-option>
            </mat-autocomplete>
        </mat-form-field>
    </div>
</div>
<mat-dialog-content class="dialog-content">
    <mat-tab-group [(selectedIndex)]="selectedTabIndex" *ngIf="formReady">
        <!-- Metadata Tab -->
        <mat-tab label="Metadata">
            <mat-card class="form-card">
                <form [formGroup]="form" class="form-grid">
                    <div *ngFor="let formField of metadataAttributes" class="form-field-wrapper">
                        <label class="grid-label" [matTooltip]="formField.description">
                            {{ formField.name }}
                            <span class="required-field" *ngIf="formField.required">*</span>
                        </label>
                        <div class="form-field-input">
                            <div *ngIf="formField.type === 'TEXT'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                                    <mat-error *ngIf="form.get(formField.jsonProperty)?.hasError('duplicateVariationLabel')">
                                        A variation with this label already exists
                                    </mat-error>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formField.type === 'TEXTAREA'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <textarea matInput
                                              cdkTextareaAutosize
                                              cdkAutosizeMinRows="3"
                                              [formControlName]="formField.jsonProperty" class="flex-100">
                                    </textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-card>
        </mat-tab>

        <!-- Attribute Overrides Tab -->
        <mat-tab label="Attribute Overrides">
            <mat-card class="form-card">
                <div *ngIf="overrideAttributes.length === 0" class="no-attributes-message">
                    <p>No attribute overrides available for this template.</p>
                </div>
                <form [formGroup]="form" class="form-grid" *ngIf="overrideAttributes.length > 0">
                    <div class="form-info-message" *ngIf="form.hasError('atLeastOneRequired')">
                        <mat-icon>info</mat-icon>
                        <span>At least one override field must be filled out</span>
                    </div>
                    <div *ngFor="let formField of overrideAttributes" class="form-field-wrapper">
                        <label class="grid-label" [matTooltip]="formField.description">
                            {{ formField.name }}
                            <span class="required-field" *ngIf="formField.required">*</span>
                        </label>
                        <div class="form-field-input">
                            <div *ngIf="formField.type === 'TEXT'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                                </mat-form-field>
                            </div>
                            <div *ngIf="formField.type === 'NUM'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <input matInput [formControlName]="formField.jsonProperty" [type]="'number'" class="flex-100">
                                </mat-form-field>
                            </div>
                            <div *ngIf="formField.type === 'BOOL'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <mat-select [formControlName]="formField.jsonProperty" class="flex-100">
                                        <mat-option *ngFor="let option of formField.options"
                                                    [value]="option.value">{{ option.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formField.type === 'TEXTAREA'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <textarea matInput
                                              cdkTextareaAutosize
                                              cdkAutosizeMinRows="3"
                                              [formControlName]="formField.jsonProperty" class="flex-100">
                                    </textarea>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formField.type === 'SELECT'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <mat-select [formControlName]="formField.jsonProperty" class="flex-100">
                                        <mat-option *ngFor="let option of formField.options"
                                                    [value]="option.value">{{ option.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formField.type === 'MULTI_SELECT'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <mat-select [formControlName]="formField.jsonProperty"
                                                multiple class="flex-100">
                                        <mat-option *ngFor="let option of formField.options"
                                                    [value]="option.value">{{ option.label }}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div *ngIf="formField.type === 'IMAGE'">
                                <mat-form-field appearance="fill" class="flex-align-center flex-100">
                                    <input matInput [formControlName]="formField.jsonProperty" [type]="'text'" class="flex-100">
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                </form>
            </mat-card>
        </mat-tab>
    </mat-tab-group>
</mat-dialog-content>
<mat-dialog-actions align="end" class="dialog-actions-fixed">
    <button mat-raised-button color="primary" type="button" mat-dialog-close (click)="close()">
        Cancel
    </button>

    <button mat-raised-button color="primary" type="submit"
            [disabled]="form?.invalid || templateForm?.invalid || !selectedLocationSet"
            (click)="save()">
        <mat-icon aria-hidden="true">save</mat-icon>
        Save
    </button>
</mat-dialog-actions>
<div class="text-center mt-2">
    <span>This variation will not be used anywhere in the menu until there are assignments on it</span>
</div>
